export default __webpack_public_path__ + "static/media/isomil850.07acf8f0.jpg";